
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { UniversityFieldResponse } from "../../models/dtos";

export const universityFieldsApi = createApi({
  reducerPath: 'universityFieldsApi',
  baseQuery: baseAuthQuery('UniversityFields'),
  tagTypes: ['UniversityField'],
  endpoints: (builder) => ({
    getUniversityFields: builder.query<ApiResponse<UniversityFieldResponse[]>, void>({
      query: () => "",
      providesTags: ['UniversityField'],
    }),
    getUniversityFieldById: builder.query<ApiResponse<UniversityFieldResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['UniversityField'],
    }),
    updateUniversityField: builder.mutation<ApiResponse<UniversityFieldResponse>, Partial<UniversityFieldResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['UniversityField'],
    }),
    deleteUniversityField: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['UniversityField'],
    }),
  }),
});
